import { LoaderActions } from '@store/loaders'
import {
  PROJECTS_LIMIT_REACHED,
  upgradeToast,
} from '@store/reducers/limitReached'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { call, put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'
import {
  type DashboardActions,
  InternalProjectActions as Internal,
} from '../../actions'
import { selectProjectParents } from '../../selectors'
import type { ProjectItem, ProjectParents } from '../../types'
import { parseNestError } from '../../utils'

export function* duplicate({
  payload: { id },
}: ReturnType<typeof DashboardActions.projects.duplicate>) {
  // todo: validate duplicate
  const path: ProjectParents | null = yield select(selectProjectParents(id))
  if (!path) {
    return
  }

  const { folder, workspace, project } = path

  yield put(LoaderActions.set(id))

  sendGtmEvent(GtmTriggerName.PROJECT_DUPLICATE)

  try {
    const newItem: ProjectItem = yield call(NestClient.projects.duplicate, {
      id,
    })

    yield put(
      Internal.add({
        project: {
          ...newItem,
          features: project.features,
          type: project.type,
        },
        folderId: folder.id,
        workspaceId: workspace.id,
      })
    )
  } catch (e) {
    const message = parseNestError(e)

    if (message === PROJECTS_LIMIT_REACHED) {
      yield* upgradeToast(message)

      return
    }

    yield put(ErrorNotification(message))
  } finally {
    yield put(LoaderActions.unset(id))
  }
}
